// extracted by mini-css-extract-plugin
module.exports = {"btn":"BookButton-module--btn--20fKz"};